export const REQUEST_LOG_EVENTS = {
  send_proposal_prepared: 'action',
  send_proposal_confirmed: 'action',
  send_proposal_cancelled: 'status_change',
  send_proposal_stale: 'status_change',
  operation_queued: 'action',
  operation_started: 'status_change',
  operation_completed: 'status_change',
  operation_failed: 'status_change',
  operation_unknown: 'status_change',
  request_created: 'action',
  rfq_created: 'action',
  details_updated: 'change',
  matching_refreshed: 'change',
  providers_updated: 'change',
  draft_saved: 'change',
  processing_completed: 'status_change',
  processing_failed: 'status_change',
  request_rejected: 'status_change',
  request_restored: 'status_change',
  customer_declined: 'status_change',
  rfq_details_updated: 'change',
  rfq_providers_updated: 'change',
  provider_quote_created: 'action',
  provider_solicitation_draft_saved: 'change',
  provider_rates_updated: 'change',
  rfq_draft_saved: 'change',
  rfq_status_changed: 'status_change',
  provider_response_received: 'status_change',
  provider_quote_status_changed: 'status_change',
  delivery_started: 'action',
  delivery_sent: 'status_change',
  delivery_failed: 'status_change',
  delivery_unknown: 'status_change',
} as const;

export type RequestLogEventName = keyof typeof REQUEST_LOG_EVENTS;
export type RequestLogCategory = (typeof REQUEST_LOG_EVENTS)[RequestLogEventName];
export type RequestLogActorKind =
  | 'operator'
  | 'system'
  | 'customer_link'
  | 'provider_link'
  | 'provider_email';
export type RequestLogSource =
  | 'mcp'
  | 'manual'
  | 'assistant'
  | 'inbound'
  | 'workflow'
  | 'public_confirmation'
  | 'provider_form'
  | 'provider_email';

/** Derived on the server; never accept attribution directly from a client. */
export interface RequestActionContext {
  actorKind: RequestLogActorKind;
  actorId?: string;
  source: RequestLogSource;
  correlationId?: string;
}

export type RequestLogJsonValue =
  | string
  | number
  | boolean
  | null
  | RequestLogJsonValue[]
  | { [key: string]: RequestLogJsonValue };

export interface RequestLogChange {
  op: 'add' | 'remove' | 'replace';
  /** JSON Pointer: array changes preserve the complete ordered array. */
  path: string;
  before?: RequestLogJsonValue;
  after?: RequestLogJsonValue;
}

export interface RequestLogSummaryDto {
  id: string;
  requestId: string;
  sequence: number;
  createdAt: string;
  category: RequestLogCategory;
  eventName: RequestLogEventName;
  payloadVersion: number;
  summary: string;
  entityType: string;
  entityId: string;
  entityRevision: string | null;
  actorKind: RequestLogActorKind;
  actorId: string | null;
  source: RequestLogSource;
  correlationId: string | null;
}

export interface RequestLogDetailDto extends RequestLogSummaryDto {
  payload: { [key: string]: RequestLogJsonValue };
}

export interface RequestLogsQuery {
  limit?: number;
  cursor?: string;
  afterSequence?: number;
  throughSequence?: number;
  category?: RequestLogCategory;
  eventName?: RequestLogEventName;
  entityType?: string;
  entityId?: string;
  actorKind?: RequestLogActorKind;
  actorId?: string;
  source?: RequestLogSource;
  from?: string;
  to?: string;
  search?: string;
}

export interface RequestLogsResult {
  data: RequestLogSummaryDto[];
  totalCount: number;
  nextCursor: string | null;
  throughSequence: number;
}
